import { render } from "./FormPhotoInside.vue?vue&type=template&id=13edaa70"
import script from "./FormPhotoInside.vue?vue&type=script&lang=js"
export * from "./FormPhotoInside.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__